import { IExamSession } from '@/shared/model/exam-session.model';
import { IInscriptionPayment, PaymentType } from '@/shared/model/inscriptionPayment.model';
import { Gender } from '@/shared/model/enumeration/gender.model';
import { Country } from '@/shared/model/enumeration/country.model';
import { Nationality } from '@/shared/model/enumeration/nationality.model';
import { ExamType } from '@/shared/model/enumeration/examType.model';

export interface IInscription {
  id?: number;
  numDossier?: string;
  numChrono?: string;
  gender?: Gender;
  firstName?: string;
  firstName2?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  mobilePhoneNumber?: string;
  birthDate?: Date;
  cityOfBirth?: string;
  countryOfBirth?: Country;
  nationality?: Nationality;
  hasPaid?: boolean;
  address1?: string;
  address2?: string;
  postalCode?: string;
  city?: string;
  country?: Country;
  cardIdentityContentType?: string;
  cardIdentity?: any;
  photoIdentityContentType?: string;
  photoIdentity?: any;
  inscriptionDate?: Date;
  examSession?: IExamSession;
  candidateIsCardHolder?: boolean;
  nameCardHolder?: string;
  address1CardHolder?: string;
  address2CardHolder?: string;
  postalCodeCardHolder?: string;
  cityCardHolder?: string;
  countryCardHolder?: string;
  phoneNumberCardHolder?: string;
  mobilePhoneNumberCardHolder?: string;
  emailCardHolder?: string;
  paymentType?: PaymentType;
  payment?: IInscriptionPayment;
  examSessionCity?: string;
  examSessionDate?: string;
  examSessionType?: ExamType;
  dualRegistration?: boolean;
}

export class Inscription implements IInscription {
  constructor(
    public id?: number,
    public numDossier?: string,
    public numChrono?: string,
    public gender?: Gender,
    public firstName?: string,
    public firstName2?: string,
    public lastName?: string,
    public email?: string,
    public phoneNumber?: string,
    public mobilePhoneNumber?: string,
    public birthDate?: Date,
    public cityOfBirth?: string,
    public countryOfBirth?: Country,
    public nationality?: Nationality,
    public hasPaid?: boolean,
    public address1?: string,
    public address2?: string,
    public postalCode?: string,
    public city?: string,
    public country?: Country,
    public cardIdentityContentType?: string,
    public cardIdentity?: any,
    public photoIdentityContentType?: string,
    public photoIdentity?: any,
    public inscriptionDate?: Date,
    public examSession?: IExamSession,
    public candidateIsCardHolder?: boolean,
    public nameCardHolder?: string,
    public address1CardHolder?: string,
    public address2CardHolder?: string,
    public postalCodeCardHolder?: string,
    public cityCardHolder?: string,
    public countryCardHolder?: string,
    public phoneNumberCardHolder?: string,
    public mobilePhoneNumberCardHolder?: string,
    public emailCardHolder?: string,
    public paymentType?: PaymentType,
    public payment?: IInscriptionPayment,
    public examSessionCity?: string,
    public examSessionDate?: string,
    public examSessionType?: ExamType,
    public dualRegistration?: boolean
  ) {
    this.hasPaid = this.hasPaid || false;
    this.candidateIsCardHolder = this.candidateIsCardHolder || true;
    this.dualRegistration = this.dualRegistration || false;
  }
}
